<template>
  <v-container>
    <h1>สร้างคำทับศัพท์</h1>
    <!-- {{ selected }}
    {{ $store.state.moduleCreateEditWord.selected_language }}-->
    <v-row>
      <v-col cols="12" sm="12" md="2" class="py-0">
        <v-checkbox
          v-model="selectedAll"
          label="เลือกภาษาทั้งหมด"
          :disabled="createMode == 'read'"
          @change="
            click_checkbox = false;
            click_select_all = true;
          "
        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="12" md="10" class="py-0">
        <v-row>
          <v-col
            md="2"
            sm="4"
            cols="6"
            class="py-0"
            v-for="item in language_list"
            :key="item.languageId"
          >
            <v-checkbox
              :disabled="createMode == 'read' || item.disabled"
              v-model="selected"
              :label="item.languageName"
              :value="item.languageId"
              @change="
                click_checkbox = true;
                click_select_all = false;
              "
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      selectedAll: false,
      selected: [],
      click_checkbox: false,
      click_select_all: false,
    };
  },
  created() {
    if (this.$route.query.id) {
      this.axios
        .get(
          process.env.VUE_APP_API +
            "api/v1/admin/romanlanguage/" +
            this.$route.query.id,
          this.header_token
        )
        .then((res) => {
          if (res) {
            var data = res.data;
            this.$store.state.moduleCreateEditWord.created_word = {
              categoryId: data.categoryId,
              mean: data.mean,
              subLanguage: data.subLanguage,
            };
            data.subLanguage.forEach((element) => {
              var include = this.$store.state.moduleCreateEditWord.selected_language.includes(
                element.languageId
              );
              var edit_include = this.$store.state.moduleCreateEditWord.selected_language_edit_mode.includes(
                element.languageId
              );
              if (include == false) {
                this.$store.state.moduleCreateEditWord.selected_language.push(
                  element.languageId
                );
              }
              if (edit_include == false) {
                this.$store.state.moduleCreateEditWord.selected_language_edit_mode.push(
                  element.languageId
                );
              }
            });
          }
        });

      this.selected = this.$store.state.moduleCreateEditWord.selected_language;

      if (this.$route.params.mode == "read_mode" && this.$route.query.id) {
        this.$store.state.moduleCreateEditWord.createMode = "read";
      }
    } else {
      if (this.$store.state.moduleCreateEditWord.createMode == "request") {
        this.selected = this.$store.state.moduleCreateEditWord.selected_language;
        this.$store.state.moduleCreateEditWord.created_word.subLanguage.forEach(
          (element) => {
            element.subLanguageStatus = this.$store.state.moduleCreateEditWord
              .btn_public
              ? "active"
              : "pending";
          }
        );
      }
    }
  },
  computed: {
    createMode() {
      return this.$store.state.moduleCreateEditWord.createMode;
    },
    language_list() {
      var language = this.$store.state.moduleCreateEditWord.language_list;

      if (this.$route.params.mode == "edit") {
        this.$store.state.moduleCreateEditWord.language_list.forEach(
          (element) => {
            if (
              this.$store.state.moduleCreateEditWord.selected_language_edit_mode.includes(
                element.languageId
              )
            ) {
              element.disabled = true;
            } else {
              element.disabled = false;
            }
          }
        );
      } else {
        this.$store.state.moduleCreateEditWord.language_list.forEach(
          (element) => {
            element.disabled = false;
          }
        );
      }
      var language = this.$store.state.moduleCreateEditWord.language_list;
      return language;
    },
  },
  watch: {
    "$store.state.moduleCreateEditWord.selected_id"(val) {
      var delete_id = [];

      for (
        var i = 0;
        i <
        this.$store.state.moduleCreateEditWord.created_word.subLanguage.length;
        i++
      ) {
        if (
          !val.includes(
            this.$store.state.moduleCreateEditWord.created_word.subLanguage[i]
              .languageId
          )
        ) {
          this.$store.state.moduleCreateEditWord.created_word.subLanguage.splice(
            i,
            1
          );
          i--;
        }
      }
    },
    selected(val) {
      this.$store.state.moduleCreateEditWord.selected_language = val;
      this.setCreateWord();
      // console.log(val);
      if (val.length != this.language_list.length) {
        this.selectedAll = false;
      }
    },
    selectedAll(val) {
      if (val == true) {
        this.language_list.forEach((element) => {
          if (!this.selected.includes(element.languageId)) {
            this.selected.push(element.languageId);
          }
        });
      } else {
        if (this.click_select_all == true) {
          if (this.$route.params.mode == "edit") {
            setTimeout(() => {
              this.selected = [];
              this.$store.state.moduleCreateEditWord.selected_language_edit_mode.forEach(
                (element) => {
                  this.selected.push(element);
                }
              );
              this.$store.state.moduleCreateEditWord.selected_language = this.selected;
              this.setCreateWord();
            }, 500);
          } else {
            this.selected = [];
            this.$store.state.moduleCreateEditWord.selected_language = [];
            this.setCreateWord();
          }
        }
      }
    },
    // selectedAll(val) {
    //   var all = [];
    //   this.setCreateWord();
    //   if (val == true) {
    //     this.language_list.forEach((element) => {
    //       var check_all = this.selected.includes(element.laguageId);
    //       if (check_all == false) {
    //         this.selected.push(element.languageId);
    //       }
    //     });
    //   } else {
    //     // this.selected = [];
    //     this.$store.state.moduleCreateEditWord.selected_language = this.selected;
    //   }
    // },
    // selected(val) {
    //   console.log(val);

    //   this.$store.state.moduleCreateEditWord.selected_language = val;
    //   this.setCreateWord();
    //   // if (val && this.language_list.length > 0) {
    //   //   if (val.length != this.language_list.length) {
    //   //     this.selectedAll = false;
    //   //   } else {
    //   //     this.selectedAll = true;
    //   //   }
    //   // }
    //   if (this.selected.length != this.language_list.length) {
    //     this.selectedAll = false;
    //   } else {
    //     this.selectedAll = true;
    //   }
    // },
  },
  methods: {
    getLanguage() {
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/masterdata/language",
          this.header_token
        )
        .then((res) => {
          var data = res.data;
          this.language_list = data;
          this.language_list.forEach((element) => {
            element.disabled = false;
          });
        });
    },
    setCreateWord() {
      var selected_language = this.$store.state.moduleCreateEditWord
        .selected_language;
      var subLanguage = [];
      var selected_id = [];
      // selected_language.forEach((element) => {
      //   var include = selected_id.includes(element);
      //   if (include == false) {
      //     selected_id.push(element);
      //     subLanguage.push({
      //       languageId: element,
      //       alphabet: "",
      //       transcription: [{ text: "" }],
      //     });
      //   }
      // });
      // this.$store.state.moduleCreateEditWord.created_word.subLanguage.forEach(element=>{
      // })
      var old_id = [];
      selected_language.forEach((element) => {
        var include = selected_id.includes(element);
        if (include == false) {
          selected_id.push(element);
        }
      });
      // console.log("ddddddddd");
      // console.log(selected_id);
      // console.log(old_id);
      this.$store.state.moduleCreateEditWord.created_word.subLanguage.forEach(
        (element) => {
          var include = old_id.includes(element.languageId);
          if (include == false) {
            old_id.push(element.languageId);
          }
        }
      );
      selected_id.forEach((element) => {
        var includes = old_id.includes(element);
        if (includes == false) {
          subLanguage.push({
            languageId: element,
            alphabet: "",
            transcriptionList: [{ transcriptionName: "" }],
            subLanguageStatus: this.$store.state.moduleCreateEditWord.btn_public
              ? "active"
              : "pending",
          });
        } else if (includes == true) {
          this.$store.state.moduleCreateEditWord.created_word.subLanguage.forEach(
            (element, index) => {
              subLanguage[index] = element;
            }
          );
        }
        //   if (includes == true) {
        //     this.$store.state.moduleCreateEditWord.created_word.forEach(
        //       (element, index) => {
        //         subLanguage[index] = element;
        //       }
        //     );
        //   } else if (includes == false) {
        //     subLanguage.push({
        //       languageId: element,
        //       alphabet: "",
        //       transcription: [{ text: "" }],
        //     });
        //   }
      });
      // console.log(subLanguage);
      // }
      this.$store.state.moduleCreateEditWord.selected_id = selected_id;
      this.$store.state.moduleCreateEditWord.created_word.subLanguage = subLanguage;
    },
  },
};
</script>
